export const outputActionFlowSummary = () => {
  const stats = window.executionStats || {};

  if (!stats || Object.keys(stats).length === 0) {
    alert('No execution data recorded.');
    return;
  }

  const sortedStats = Object.entries(stats)
    .map(([uid, data]) => ({ uid, ...data }))
    .sort((a, b) => b.total - a.total);

  const tableHtml = `
    <html>
    <head>
      <title>Execution Summary</title>
      <style>
        table {
          border-collapse: collapse;
          width: 100%;
        }
        th, td {
          border: 1px solid black;
          padding: 8px;
          text-align: left;
        }
        th {
          background-color: #f2f2f2;
        }
        .copy-btn {
          background-color: #4CAF50;
          color: white;
          border: none;
          padding: 5px 10px;
          cursor: pointer;
          border-radius: 4px;
        }
        .danger{
        color: red;
        font-weight: bolder;
        }
        .copy-btn:hover {
          background-color: #45a049;
        }
        .summary-row {
          font-weight: bold;
          background-color: #e8f5e9;
        }
      </style>
    </head>
    <body>
      <h2>Execution Summary</h2>
      <table>
        <thead>
          <tr>
            <th>UID</th>
            <th>Total Time (s)</th>
            <th>Longest Time (s)</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          ${sortedStats
    .map(
      (row) => `
            <tr>
              <td>${row?.currentRule?.name ?? row?.currentRule?.uid ?? 'unknown'}</td>
              <td class="${row.total > 1 ? 'danger' : ''}">${row.total.toFixed(3)}</td>
              <td>${row.longest.toFixed(3)}</td>
              <td><button class="copy-btn" onclick="copyToClipboard('${row.uid}')">Copy</button></td>
            </tr>
            <tr class="summary-row">
              <td colspan="4">Summary for UID "${row.uid}": Total Time = ${row.total.toFixed(
        3
      )} seconds, Longest Time = ${row.longest.toFixed(3)} seconds</td>
            </tr>
          `
    )
    .join('')}
        </tbody>
      </table>
      <script>
        function copyToClipboard(text) {
          navigator.clipboard.writeText(text).then(() => {
            alert('Copied to clipboard: ' + text);
          }).catch(err => {
            alert('Failed to copy: ' + err);
          });
        }
      </script>
    </body>
    </html>
  `;

  const newWindow = window.open('', '_blank');
  newWindow.document.open();
  newWindow.document.write(tableHtml);
  newWindow.document.close();
}